import React, { ReactNode } from 'react';
import './Patterns.css';

export interface FormSectionProps {
  /** id used both as the DOM id and as the FormShell TOC anchor target. */
  id: string;
  title: string;
  description?: ReactNode;
  children: ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ id, title, description, children }) => (
  <section id={id} className="pat-form-section" data-testid={`form-section-${id}`}>
    <h3 className="pat-form-section__title">{title}</h3>
    {description && (
      <p className="pat-form-section__description" data-testid="form-section-description">
        {description}
      </p>
    )}
    <div className="pat-form-section__body">{children}</div>
  </section>
);

export default FormSection;
